import { FormContextProvider } from "@sw-sw/lib-form";
import React from "react";

const FreeTrialLayout: React.FC = ({children}) => {
  return (
    <div style={{ background: "black", height: "100vh" }}>
      <FormContextProvider>
        {children}
      </FormContextProvider>
      
    </div>
  );
};

export default FreeTrialLayout;
